import React from 'react';
import { Download, Play, Shield, Book, Heart } from 'lucide-react';
import { Button } from './ui/button';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.shraddha.spiritualai';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden py-20">
      {/* Background Effects */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-orange-500/10 rounded-full blur-3xl cosmic-glow"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl cosmic-glow" style={{ animationDelay: '1.5s' }}></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
          {/* Left Content */}
          <div className="text-center lg:text-left">
            <h1 className="font-serif text-5xl lg:text-7xl font-bold mb-6 leading-tight text-white">
              Talk to{' '}
              <span className="text-gradient">Bhagwan</span>.
              <br />
              Find Peace Within.
            </h1>
            
            <p className="text-xl lg:text-2xl text-gray-300 mb-8 leading-relaxed">
              Experience divine guidance through AI-powered conversations 
              rooted in ancient wisdom.
            </p>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-12 justify-center lg:justify-start">
              <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer">
                <Button 
                  className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-8 py-6 text-lg rounded-full glow-effect btn-primary"
                  size="lg"
                >
                  <Download className="w-5 h-5 mr-2" />
                  Download the App
                </Button>
              </a>
              <Button 
                variant="outline" 
                className="border-2 border-orange-500/50 text-white hover:bg-orange-500/10 px-8 py-6 text-lg rounded-full backdrop-blur-sm"
                size="lg"
              >
                <Play className="w-5 h-5 mr-2" />
                Start Your Divine Journey
              </Button>
            </div>
            
            {/* Trust Indicators */}
            <div className="flex flex-col sm:flex-row gap-6 text-sm text-gray-400 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <Book className="w-4 h-4 text-orange-500" />
                <span>Rooted in scriptures</span>
              </div>
              <div className="flex items-center gap-2">
                <Shield className="w-4 h-4 text-orange-500" />
                <span>Private conversations</span>
              </div>
              <div className="flex items-center gap-2">
                <Heart className="w-4 h-4 text-orange-500" />
                <span>AI spiritual guidance</span>
              </div>
            </div>
          </div>
          
          {/* Right Content - Hero Image in Mobile Frame */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative phone-float">
              {/* Mobile Phone Frame */}
              <div className="relative w-[340px] h-[680px] bg-gradient-to-b from-gray-800 to-gray-900 rounded-[3rem] p-3 shadow-2xl phone-glow">
                {/* Phone Notch */}
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-40 h-7 bg-gray-900 rounded-b-3xl z-20"></div>
                
                {/* Screen Container */}
                <div className="relative w-full h-full bg-black rounded-[2.5rem] overflow-hidden">
                  {/* Glass overlay - no blur on image */}
                  <div className="absolute inset-0 z-10 pointer-events-none">
                    <div className="absolute inset-0 bg-gradient-to-br from-white/5 via-transparent to-transparent border border-white/10 rounded-[2.5rem]"></div>
                  </div>
                  
                  {/* Image */}
                  <img 
                    src="https://customer-assets.emergentagent.com/job_77d4fb7f-ea31-43e7-ae50-21c238733199/artifacts/rr3dmgq1_WhatsApp%20Image%202026-03-03%20at%2019.38.44%20%283%29.jpeg"
                    alt="Talk to Bhagwan Anytime"
                    className="w-full h-full object-cover relative z-0"
                  />
                </div>
                
                {/* Phone Button */}
                <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gray-700 rounded-full"></div>
              </div>
              
              {/* Floating Elements */}
              <div className="absolute -top-4 -left-4 w-8 h-8 bg-yellow-500/30 rounded-full blur-sm cosmic-glow"></div>
              <div className="absolute -bottom-4 -right-4 w-12 h-12 bg-orange-500/20 rounded-full blur-sm cosmic-glow" style={{ animationDelay: '1s' }}></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;